"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpinButton = void 0;

var tslib_1 = require("tslib");

var ui_blocks_1 = require("@hopin-team/ui-blocks");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var ui_helper_props_to_styles_1 = require("@hopin-team/ui-helper-props-to-styles");

var styled_components_1 = tslib_1.__importStar(require("styled-components"));

var isClickable = ui_blocks_1.INTERACTIVE.isClickable,
    isClickableInverse = ui_blocks_1.INTERACTIVE.isClickableInverse;
var Sizes;

(function (Sizes) {
  Sizes[Sizes["tiny"] = 0.5] = "tiny";
  Sizes[Sizes["small"] = 0.65] = "small";
  Sizes[Sizes["medium"] = 0.75] = "medium";
  Sizes[Sizes["large"] = 0.85] = "large";
})(Sizes || (Sizes = {}));

var makeSizeStyles = function makeSizeStyles(sizeOption) {
  return (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  width: ", "rem;\n  height: ", "rem;\n"], ["\n  width: ", "rem;\n  height: ", "rem;\n"])), Sizes[sizeOption], Sizes[sizeOption]);
};

exports.SpinButton = styled_components_1.default.button(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  ", "\n  ", "\n  border-radius: 0;\n  display: flex;\n  justify-content: center;\n  background: none;\n  border: 0.0625rem solid\n    ", ";\n\n  ", ";\n\n  &:first-of-type {\n    border-top-right-radius: ", ";\n    border-top-left-radius: ", ";\n    align-items: flex-end;\n    border-bottom: none;\n  }\n\n  &:last-of-type {\n    border-bottom-right-radius: ", ";\n    border-bottom-left-radius: ", ";\n    align-items: flex-start;\n    border-top: none;\n  }\n"], ["\n  ", "\n  ", "\n  border-radius: 0;\n  display: flex;\n  justify-content: center;\n  background: none;\n  border: 0.0625rem solid\n    ", ";\n\n  ", ";\n\n  &:first-of-type {\n    border-top-right-radius: ", ";\n    border-top-left-radius: ", ";\n    align-items: flex-end;\n    border-bottom: none;\n  }\n\n  &:last-of-type {\n    border-bottom-right-radius: ", ";\n    border-bottom-left-radius: ", ";\n    align-items: flex-start;\n    border-top: none;\n  }\n"])), isClickable, function (_a) {
  var isInverse = _a.isInverse;
  return isInverse && isClickableInverse;
}, function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY["400"]', theme);
}, function (props) {
  return (0, ui_helper_props_to_styles_1.makeStyles)(props, 'sizeOption', makeSizeStyles);
}, function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('LINE.RADIUS_DEFAULT', theme);
}, function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('LINE.RADIUS_DEFAULT', theme);
}, function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('LINE.RADIUS_DEFAULT', theme);
}, function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('LINE.RADIUS_DEFAULT', theme);
});
var templateObject_1, templateObject_2;